<template>
    <b-modal :visible="Visible" centered no-close-on-backdrop no-close-on-esc  v-if="$store.getters['CheckAction']('Read', undefined, Action)">
        <template #modal-header>
            <h6>{{ $t('SavedShareElementType', { type : Title }) }} </h6> <!-- {{ Title }} enregistrés -->
            <b-icon role="button" icon="x-lg" font-scale="1.5" @click="$emit('CloseEvent');" v-b-tooltip.hover :title="$t('Close')" />
        </template>

        <!-- Ligne permettant la sélection/déselection des élements du tableau + bouton partager -->
        <b-row class="pb-2">
            <b-col cols="auto" class="pr-0">
                <!-- Sélection complete des elements -->
                <b-button v-b-tooltip.hover.top :title="$t('SelectAll')" variant="outline-dark" 
                    class="btn-circle border-0" @click="select(true)">
                    <b-icon icon="check2-all" />
                </b-button>
                <!-- Déselection complète des élements -->
                <b-button v-b-tooltip.hover.top :title="$t('ClearSelection')" variant="outline-dark"
                    class="btn-circle border-0" @click="select(false)">
                    <font-awesome-icon icon="square-xmark"  />
                </b-button>
            </b-col>
            <b-col>
                <!-- Barre de recherche -->
                <b-input-group>
                    <template #prepend>
                        <b-input-group-text><b-icon icon="search"/></b-input-group-text>
                    </template>

                    <b-form-input v-model="searchValue" :placeholder="$t('SearchShareElement', { type : Title.toLowerCase() })"/> <!--  'Rechercher un ' + Title?.toLowerCase() -->
                </b-input-group>
            </b-col>
        </b-row>

        <!-- Tableau des données -->
        <b-table :id="$id('shareItems')" selectable select-mode="multi" sort-by="Share" sort-desc :items="itemsList" :fields="fieldsList" :no-select-on-click="Visible" 
                    :per-page="itemPerPage" :current-page="currentPage" show-empty :empty-text="$t('EmptyShareElements', { type : Title.toLowerCase() })" :filter="searchValue" @filtered="onFiltered" > <!-- 'Aucun '+ Title + ' enregistrés' -->
            <!-- Cellule permettant la sélection d'éléménts via une case à cocher -->
            <template #cell(Selected)="{ item, field: { key }}">
                <b-form-checkbox v-if="!item.Share" v-model="item[key]"
                    @change="checkedShare(item, item[key])"
                    :disabled="!$store.getters['CheckAction']('Write', undefined, Action)"
                />
            </template>
            <template #cell(Label)="data">
                {{ data.value }}
            </template>

            <!-- Cellule affichant le choix du partage en attente -->
            <template #cell(Share)="data">
                <template v-if="data.value">
                    <b-icon role="button" icon="check" scale="2" v-b-tooltip.hover :title="$t('AcceptShare')" class="mr-2 text-success" @click="updateShare(data.item.Id, true)" />    
                    <b-icon role="button" icon="x" scale="2" v-b-tooltip.hover :title="$t('DeclineShare')" class="ml-2 text-danger" @click="updateShare(data.item.Id, false)" />    
                </template>
            </template>

            
        </b-table>

        <template #modal-footer="{ cancel }">
            <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="itemPerPage" class="mr-auto" />
            <b-button :variant="'outline-'+Variant" pill @click="$emit('CancelEvent');cancel();">{{ $t('Previous') }}</b-button>
            <b-button pill :variant="Variant" @click="$emit('ShowUsersEvent')" :disabled="shareIds.length == 0 || !$store.getters['CheckAction']('Write', undefined, Action)">{{ $t('Next') }}</b-button>
        </template>
    </b-modal>
</template>

<script lang="ts">
    import { Prop, Vue, PropSync, InjectReactive } from 'vue-property-decorator';
    import ShareUsers from './ShareUsers.vue';
    import { ThemeUtils } from '@/components/commons/Utils';
    import Component, { mixins } from 'vue-class-component';
    import ShareItem from '@/types/ShareItem';
    import { API_URL, MAIN_FILTER_TREE } from '@/App.settings';
    import axios from 'axios';
    import ListItem from '@/types/fields/ListItem';
    import Dictionary from '@/types/Dictionary';
    import locales from './locales/ShareComponent.json';

    /** Composant permettant l'affichage des différents elements à partager */
    @Component({
        components: {
            ShareUsers
        },
        i18n : { messages : locales }
    })
    export default class ShareComponent extends mixins(ThemeUtils){
        /** Indication pour afficher ou non la modale */
        @Prop()
        public Visible!: boolean;

        @PropSync("ShareIds")
        public shareIds!: string[];

        @PropSync("ShareType")
        public shareType!: string;

        @Prop()
        public Variant!: string;

        @Prop()
        public Title!: string;

        /** Droit disponible pour l'utilisateur en cours */
        @InjectReactive()
        public Action!: string;

        /** Liste des élements à afficher / partager */
        private itemsList: ShareItem[] = [];
        
        /** Nombre de lignes dans le tableau */
        private totalRows: number = 1;

        /** Numéro de la page courante du tableau */
        private currentPage: number = 1;

        /** Nombre d'éléments par page */
        private itemPerPage: number = 10;

        /** Valeur pour rechercher un composant */
        private searchValue: string = "";

        /** Liste des champs du tableau */
        private fieldsList = [
            {
                key:"Selected",
                label:"",
            },
            {
                key:"Label",
                label: this.$t('Name').toString(),
                tdClass:"w-100"
            },
            {
                key:"Share",
                label: this.$t('Share').toString(),
            }
        ]
       
        /**
         * Permet la sélection du tableau à partir d'une checkbox
         * @param index 
         * @param checked 
         */
        private checkedShare(item, value){
            console.debug("ShareComponent - checkedShare - item['Id'] : ", item['Id']);

            console.debug("ShareComponent - checkedShare - itemsList : ", this.itemsList);
            console.debug("ShareComponent - checkedShare - filterItems : ", this.itemsList.find(u => u.Id == item['Id']).Selected);

            //this.itemsList.find(u => u.Id == item['Id']).Selected = value;

            this.shareIds = this.itemsList.filter(u => u.Selected).map(u => u.Id.toString());
        }

        /**
         * Permet la sélection/désélection complete du tableau
         * @param all Indique si on veut tout sélectionner/désélectionner
         */
        private select(all: boolean){

            console.debug("ShareComponent - select - filterItems : ", this.itemsList.filter(u => u.Share == false));

            // Sélectionne tous les éléments non partagés
            this.itemsList.filter(u => u.Share == false).forEach(u => {
                u.Selected = all;
            })

            this.shareIds = this.itemsList.filter(u => u.Selected).map(u => u.Id.toString());
        }

        /**
         * Permet la mise à jour des éléments en attente de partage
         * @param id Identifiant du partage
         * @param accept Indique si on accepte ou non le partage
         */
        private async updateShare(id: number, accept: boolean ){
            console.debug("ShareComponent - updateShare - id : %O | accept? : %O", id, accept, );

            // Ecran de chargement
            this.$store.dispatch("ShowLoadingMask", this.$t('ShareInProgress').toString());

            await this.$store.dispatch("UpdateShareItem" , { id, accept, shareType: this.shareType }).then(async () => {
                // selon this.shareType => mise à jour liste correspondante
                switch (this.shareType) {
                    case "Dashboard":
                        this.$store.dispatch("MainDashboardStore/LoadData");
                        break;
                    case "Perimeter":
                        this.$store.dispatch(MAIN_FILTER_TREE + '/LoadFilters');
                        break;
                    case "Mask":
                        // const args: Dictionary<any> = {};
                        // args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";

                        // await axios.post<ListItem[]>(API_URL + "Feature/LoadMasks", args).then(() => {
                        //     console.debug("ShareComponent - LoadMasks");
                        // })
                        break;
                }

                // accept ? 1 : 2 est important !!!! -> permet d'afficher soit le message d'acceptation du partage soit le message de refus (via plurialization i18n)
                this.$bvToast.toast(this.$tc('UpdateShareItem', accept ? 1 : 2).toString(), {
                    title: this.$t('Share').toString(),
                    autoHideDelay: 2000,
                        variant: "success",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                });
            }).catch(err => {
                console.error(err);
                this.$bvToast.toast(this.$t('UpdateShareItemsErrorOccured').toString(), {
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            }).finally(() => {
                this.$store.dispatch("HideLoadingMask", {});
            });
        }

        /**
         * Fonction pour filtrer les éléments du tableau dans le b-table
         * @param filteredItems liste des éléments filtrés selon la valeur recherchée 
         */
         private onFiltered(filteredItems){
            this.totalRows = filteredItems.length
            this.currentPage = 1;
        }

        /** 
         * Pointeur vers fonction pour désactiver watchers
         * @see https://vuejs.org/guide/essentials/watchers#stopping-a-watcher
         **/
        private unwatchGetSharableItems = undefined;

        mounted(){
            console.debug("ShareComponent - mounted - shareType: ", this.shareType);

            // mettre ds fn à part ?
            this.unwatchGetSharableItems = this.$store.watch((state, getters) => getters['GetSharableItems'], val => {
				this.itemsList = val;
                this.itemsList = this.itemsList.filter(u => u.ShareType == this.shareType);
				this.totalRows = this.itemsList.length;
			}, { immediate: true });

            console.debug("ShareComponent - mounted - itemsList: ", this.itemsList);
        }       
        
        beforeDestroy() {
            // Libération watchers
            if (this.unwatchGetSharableItems)
                this.unwatchGetSharableItems();
        }
    }
</script>

<style scoped>
</style>